(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.disabled = this.getAttribute('data-sticky-type') === 'none';
      this.headerBounds = {};
      this.setHeaderHeight = () => document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight);
      if (this.disabled) return;
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      }).observe(this.header);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.setHeaderHeight);
      if (this.onScrollHandler) window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      if (document.body.classList.contains('nm-menu-open')) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.querySelectorAll('nm-mega-menu details[open]').forEach((d) => d.removeAttribute('open'));
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  class NmMenuDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.nm-md__panel');
      this.onOpen = (e) => this.open(e.currentTarget);
      this.openers = document.querySelectorAll('[data-nm-menu-open]');
      this.openers.forEach((b) => b.addEventListener('click', this.onOpen));
      this.querySelectorAll('[data-nm-menu-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.addEventListener('keyup', (e) => e.key === 'Escape' && this.close());
    }

    disconnectedCallback() {
      this.openers.forEach((b) => b.removeEventListener('click', this.onOpen));
      document.body.classList.remove('nm-menu-open');
    }

    open(trigger) {
      this.trigger = trigger;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('nm-menu-open');
      if (typeof trapFocus === 'function') trapFocus(this.panel);
      else this.panel.focus();
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nm-menu-open');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.trigger);
    }
  }
  if (!customElements.get('nm-menu-drawer')) customElements.define('nm-menu-drawer', NmMenuDrawer);

  class NmMegaMenu extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.hover = window.matchMedia('(hover: hover)');
      this.li = this.closest('li') || this;
      this.li.addEventListener('mouseenter', () => this.hover.matches && this.details.setAttribute('open', ''));
      this.li.addEventListener('mouseleave', () => this.hover.matches && this.details.removeAttribute('open'));
      this.onDocClick = (e) => !this.contains(e.target) && this.details.removeAttribute('open');
      document.addEventListener('click', this.onDocClick);
      this.addEventListener('keyup', (e) => e.key === 'Escape' && this.details.removeAttribute('open'));
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
    }
  }
  if (!customElements.get('nm-mega-menu')) customElements.define('nm-mega-menu', NmMegaMenu);

  } catch(e) { console.error(e); }
})();
})();
